/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/9/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {StatusEnum} from "@/core/components/Status/StatusEnum";
import {CoachingPackageType} from "@shared/CoachingPackage/CoachingPackageType.js";

export default class CoachingPackageRef extends BaseObject {

	id: string = null
	title: string = null
	status: StatusEnum = null
	packageType: CoachingPackageType = null


	constructor(id: string, title: string, status: StatusEnum, packageType: CoachingPackageType) {
		super();
		this.id = id;
		this.title = title;
		this.status = status;
		this.packageType = packageType || CoachingPackageType.ONE_ON_ONE
	}

	isGroupPackage(){
		return this.packageType === CoachingPackageType.GROUP
	}

	setIsOneOnOnePackage(){
		this.packageType = CoachingPackageType.ONE_ON_ONE
	}

}
